class VideoModal {
  constructor() {
    this.modal = document.querySelector('.video-slider-modal');
    this.player = this.modal.querySelector('.video-slider-modal-player');
    this.videos = this.player.querySelectorAll('.video-slider-video');
    this.playButton = this.player.querySelector('.video-slider-slide-play-button');
    this.currentIndex = 0;
    this.currentVideo = null;

    this.initVideos();
    this.bindEvents();
  }

  initVideos() {
    this.videos.forEach(video => {
      video.style.display = 'none';
    });

    this.playButton.style.display = 'none';
  }

  bindEvents() {
    document.querySelectorAll('.video-thumbnail').forEach(thumbnail => {
      thumbnail.addEventListener('click', (e) => {
        const index = parseInt(e.currentTarget.dataset.videoIndex);
        this.open(index);
      });
    });

    this.modal.querySelector('.video-slider-modal-backdrop').addEventListener('click', () => this.close());
    this.modal.querySelector('.video-slider-modal-container').addEventListener('click', (e) => {
      if (e.target === e.currentTarget) {
        this.close();
      }
    });

    this.modal.querySelector('.video-slider-modal-close').addEventListener('click', () => this.close());
    this.modal.querySelector('.video-slider-modal-prev').addEventListener('click', () => this.prev());
    this.modal.querySelector('.video-slider-modal-next').addEventListener('click', () => this.next());

    this.playButton.addEventListener('click', () => {
      if (this.currentVideo) {
        this.currentVideo.play();
        this.playButton.style.display = 'none';
      }
    });

    document.addEventListener('keydown', (e) => {
      if (!this.isOpen()) return;

      const keyActions = {
        'Escape': () => this.close(),
        'ArrowLeft': () => this.prev(),
        'ArrowRight': () => this.next(),
        ' ': () => {
          e.preventDefault();
          this.togglePlayPause();
        }
      };

      const action = keyActions[e.key];
      if (action) action();
    });
  }

  bindVideoEvents(video) {
    video.onclick = () => this.togglePlayPause();
    video.onpause = () => this.playButton.style.display = 'block';
    video.onplay = () => this.playButton.style.display = 'none';
    video.onended = () => this.autoAdvance();
  }

  togglePlayPause() {
    if (!this.currentVideo) return;

    if (this.currentVideo.paused) {
      this.currentVideo.play();
    } else {
      this.currentVideo.pause();
    }
  }

  autoAdvance() {
    const nextIndex = this.currentIndex < this.videos.length - 1 ? this.currentIndex + 1 : 0;
    this.showVideo(nextIndex);
    this.currentIndex = nextIndex;
  }

  resetVideo(video) {
    video.pause();
    video.currentTime = 0;
    video.style.display = 'none';
  }

  open(index) {
    this.currentIndex = index;
    this.showVideo(index);
    this.modal.style.display = 'block';

    document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
  }

  close() {
    this.modal.style.display = 'none';

    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

    this.videos.forEach(video => this.resetVideo(video));
    this.playButton.style.display = 'none';
    this.currentVideo = null;
  }

  prev() {
    const newIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.videos.length - 1;
    this.showVideo(newIndex);
    this.currentIndex = newIndex;
  }

  next() {
    const newIndex = this.currentIndex < this.videos.length - 1 ? this.currentIndex + 1 : 0;
    this.showVideo(newIndex);
    this.currentIndex = newIndex;
  }

  showVideo(index) {
    if (this.currentVideo) {
      this.resetVideo(this.currentVideo);
    }

    this.currentVideo = this.videos[index];
    this.currentVideo.style.display = 'block';

    this.bindVideoEvents(this.currentVideo);

    this.currentVideo.play().catch(e => {
      this.playButton.style.display = 'block';
    });
  }

  isOpen() {
    return this.modal.style.display !== 'none';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  new VideoModal();

  const videoSlider = document.querySelector('.video-slider-swiper');
  if (videoSlider) {
    const slidesMobile = parseFloat(videoSlider.dataset.slidesMobile) || 3;
    const slidesDesktop = parseFloat(videoSlider.dataset.slidesDesktop) || 4;

    new Swiper(videoSlider, {
      slidesPerView: slidesMobile,
      spaceBetween: 5,
      allowTouchMove: true,
      navigation: {
        nextEl: '.video-slider-modal-button-next, .video-slider-side-next',
        prevEl: '.video-slider-modal-button-prev, .video-slider-side-prev',
      },
      breakpoints: {
        989: {
          slidesPerView: slidesDesktop,
          spaceBetween: 5
        }
      }
    });
  }
});